/* ================ USE FILTERED NAV ITEMS HOOK ================ */
import { useMemo } from 'react';

import { paths } from 'src/routes/paths';

import { NAV_ITEMS } from 'src/online-payment/constants';

import { useCustomerPermission } from './useCustomerPermission';

/**
 * Hook that returns navigation items filtered based on user permissions.
 * Automatically hides navigation items that require permissions the user doesn't have.
 *
 * @returns Filtered array of navigation items
 *
 * @example
 * ```tsx
 * import { useFilteredNavItems } from 'src/online-payment/hooks';
 *
 * function Navbar() {
 *   const navItems = useFilteredNavItems();
 *
 *   return (
 *     <nav>
 *       {navItems.map(item => (
 *         <NavLink key={item.path} to={item.path}>{item.title}</NavLink>
 *       ))}
 *     </nav>
 *   );
 * }
 * ```
 */
export function useFilteredNavItems() {
  const { canUseCustomerDetails } = useCustomerPermission();

  return useMemo(
    () =>
      NAV_ITEMS.filter((item) => {
        // Hide Customers nav item if permission is disabled
        if (item.path === paths.pointPay.customers && !canUseCustomerDetails) {
          return false;
        }
        return true;
      }),
    [canUseCustomerDetails]
  );
}
